import React, { useEffect } from "react";

import Banner from "../../components/Banner";
import Offer from "../../components/Offer";
import Projects from "./components/Projects";
import Process from "./components/Process";
import Services from "./components/Services";
import Boost from "./components/Boost";
import CardEmprunteur from "../../components/CardEmprunteur";
import LendAvantages from "../../components/LendAvantages";
import TrustPilotCarousel from "./components/TrustPilotCarousel";
import TrustPilotReview from "./components/TrustPilotReview";
import { useToasts } from "../../hooks/useToasts";
import { useLocation, useNavigate } from "react-router-dom";
import Actualities from "./components/Actualities";
import Questions from "./components/Questions";
import { useGoogleTag } from "../../hooks/useGoogleTag";
import { useTrustpilot } from "../../hooks/useTrustpilot";
import Invest from "./components/Invest";
import PageWrapper from "../../components/ui/wrappers/PageWrapper";
import Seo from "../../components/Seo";
import StoreBadges from "../MobileApp/StoreBadges";

const Home = () => {
    const userType = "preteur";
    const { pushToast } = useToasts();
    const location = useLocation();
    const navigate = useNavigate();
    const backgroundClass = userType === "emprunteur" ? "bg-primary" : "bg-secondary";
    const lightClass = userType === "emprunteur" ? "bg-primaryLight" : "bg-secondaryLight";
    const darkClass = userType === "emprunteur" ? "bg-primaryDark" : "bg-secondaryDark";

    useGoogleTag("AW-948325592");
    useTrustpilot();

    useEffect(() => {
        if (location.state?.fromNotFound) {
            pushToast({
                content: "La page demandee n'existe pas",
                type: "error",
                position: "topCenter",
                duration: 3
            });

            navigate(".", { replace: true, state: {} });
        }
    }, [location.state]);

    return (
        <>
            <Seo
                title="PretUp - Plateforme de financement participatif pour les entreprises"
                description="Pretup est une plateforme de prets en crowdlending entre particuliers et entreprises. Pretez a des entreprises en croissance en echange d'un rendement allant jusqu'a 11% !"
            />
            <Banner userType={userType} />
            <PageWrapper>
                <StoreBadges size="small" className="-mt-2 mb-10 justify-center md:-mt-4" />
                <TrustPilotReview />
                <Projects />
                <Boost />
                <Offer
                    backgroundClass={backgroundClass}
                    lightClass={lightClass}
                    darkClass={darkClass}
                />
                <Invest />
                <LendAvantages />
                <Process />
                <Services />
                <TrustPilotCarousel />
                <CardEmprunteur />
                <Actualities />
                <Questions />
            </PageWrapper>
        </>
    );
};

export default Home;
